import Config from './Config';

var projectsItemsCarousel = []
var projectsSlider = null

export default class Homepage {

    constructor(props) {
        this.initCarousel();
        this.initHomepageMenu();
        this.initScrollDown();
    }

    initCarousel() {

        var self = this
        $('.home-carousel,.page-carousel').carousel()

        projectsItemsCarousel = $('.projects-slider > li').clone(true,true)

        $('#projectsFilter li a').on('click', function(event) {

            var isActiveCategory = !$(this).closest('li').hasClass('active')

            var category = $(this).attr('href').replace('#', '')
            var categoryItems = projectsItemsCarousel

            if(isActiveCategory){
                categoryItems = projectsItemsCarousel.filter('.' + category)
            }

            if($(window).width() > 768){
                projectsSlider.destroySlider()

                $('.projects-slider').empty().append(categoryItems.clone(false, true))

                projectsSlider = self.initProjectsSlider()
            }
            else{

                if(isActiveCategory){
                    $('.mobile-projects-list .projects').empty().append(categoryItems)

                    $(this).closest('li').after($('.mobile-projects-list'))

                    $('.mobile-projects-list').addClass('active')
                }
                else{
                    $('.mobile-projects-list').removeClass('active')
                }

            }

            $('#projectsFilter > li').not('.mobile-projects-list').removeClass('active')

            if(isActiveCategory){
                $(this).closest('li').addClass('active')
            }

            self.initProjectsBackground()

            return false
        })

        if ($('.projects-slider').length && $(window).width() > 768) {
            projectsSlider = this.initProjectsSlider()
        }

    }

    initProjectsBackground(){
        $('.projects-slider [data-background], .projects [data-background').each(function(index, el) {
            $(el).css('background-image', 'url(' + $(el).data('background') + ')');
        })
    }

    initProjectsSlider(){
        var pjs = $('.projects-slider').bxSlider({
            minSlides: 3,
            maxSlides: 3,
            slideWidth: $(window).width() / 3,
            slideMargin: 10,
            pager: false,
            touchEnabled: false,
            oneToOneTouch: false,
            controls: $('.projects-slider .item').length > 3,
            infiniteLoop: false,
            hideControlOnEnd: true
        })

        return pjs
    }

    initHomepageMenu() {
        $('.mobile-menu-toggler').on('click', function(event) {
            $(this).toggleClass('open');
            if ($(this).hasClass('open')) {
                $('.navbar-talisman').addClass('open');
                $('body').addClass('menu-open');
            } else {
                $('.navbar-talisman').removeClass('open');
                $('body').removeClass('menu-open');
            }
        });
    }

    initScrollDown() {
        $('.scrolldown').on('click', function(event) {
            $('html,body').animate({ scrollTop: $('section.section-home-about').offset().top - 120 }, 500);
            return false;
        });
    }
}



// WEBPACK FOOTER //
// src/scripts/Homepage.js